import { render } from "./App.vue?vue&type=template&id=e664491c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e664491c&lang=scss"
script.render = render

export default script